import { CheckIcon, ClockIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { isDateInThisWeek } from "../../helpers/utils/calendar.util";
import { Vacancy } from "../../models/vacancy/vacancy";
import { ContentComponent } from "../ui-lib/content-factory/ContentComponent";
import { ContentFactory } from "../ui-lib/content-factory/ContentFactory";
import { IContent } from "../ui-lib/content-factory/IContent";

const getVacancyStatusContent = (vacancy: Vacancy): IContent | undefined => {
  if (vacancy.lessons.every((l) => !!l.teacherAccepted)) {
    return ContentFactory.createBadge()
      .withCustomContent(
        ContentFactory.createIcon(<CheckIcon className="h-5 w-5"></CheckIcon>),
      )
      .withTitle("Voll besetzt")
      .withStyle("bg-green-900 text-white");
  } else if (
    vacancy.endDate < new Date() &&
    vacancy.lessons.some((l) => !l.teacherAccepted)
  ) {
    return ContentFactory.createBadge()
      .withCustomContent(
        ContentFactory.createIcon(<XMarkIcon className="h-5 w-5"></XMarkIcon>),
      )
      .withTitle("Ausfall")
      .withStyle("bg-red-400 text-white");
  } else if (
    vacancy.lessons.some(
      (l) =>
        !l.teacherAccepted &&
        new Date(l.date) >= new Date() &&
        isDateInThisWeek(l.date),
    )
  ) {
    return ContentFactory.createBadge()
      .withCustomContent(
        ContentFactory.createIcon(<ClockIcon className="h-5 w-5"></ClockIcon>),
      )
      .withTitle("Noch unbesetzte Lektionen diese Woche")
      .withStyle("bg-orange-900 text-white font-bold");
  } else {
    return undefined;
  }
};

function VacancyStatus({ vacancy }: { vacancy: Vacancy }) {
  return (
    <ContentComponent
      content={getVacancyStatusContent(vacancy)}
    ></ContentComponent>
  );
}

export default VacancyStatus;
